export const validateBasicInformation = (formData) => {
  return formData.title.length > 0 && formData.spendingGoalKey.length > 0 && formData.faq.length > 0 && formData.iconUrl.length > 0;
};

export const validateDisplayConfiguration = (formData) => {
  if (!formData.displayConfiguration?.trim()) {
    return false;
  }

  try {
    const config = JSON.parse(formData.displayConfiguration);
    // Validate that it's an object with onboardingScreens property
    return (
      typeof config === "object" &&
      config !== null &&
      Array.isArray(config.onboardingScreens) &&
      config.onboardingScreens.length > 0
    );
  } catch {
    return false;
  }
};

export const validateSelectionCriteria = (formData) => {
  if (!formData.selectionCriteria?.trim()) {
    return false;
  }

  try {
    const criteria = JSON.parse(formData.selectionCriteria);
    // Validate that it has at least one selection criteria
    // vendorId, joroSubcategoryId, or joroCategoryId should be a non-empty array
    return (
      (Array.isArray(criteria.vendorId) && criteria.vendorId.length > 0) ||
      (Array.isArray(criteria.joroSubcategoryId) && criteria.joroSubcategoryId.length > 0) ||
      (Array.isArray(criteria.joroCategoryId) && criteria.joroCategoryId.length > 0)
    );
  } catch {
    return false;
  }
};

export const validateOnboardingScreens = (onboardingScreens) => {
  return Array.isArray(onboardingScreens) && onboardingScreens.length > 0 && onboardingScreens.every(screen =>
    screen.title && screen.title.length > 0 &&
    screen.subtitle && screen.subtitle.length > 0 &&
    screen.body && screen.body.length > 0 &&
    screen.iconUrl && screen.iconUrl.length > 0 &&
    screen.identifier && screen.identifier.length > 0
  );
};

export const getCompletionStatus = (formData, onboardingScreens = []) => {
  return {
    basicInformation: validateBasicInformation(formData),
    onboardingScreens: validateOnboardingScreens(onboardingScreens),
    displayConfiguration: validateDisplayConfiguration(formData),
    selectionCriteria: validateSelectionCriteria(formData)
  };
};

export const isCompleted = (completionStatus) => {
  return Object.values(completionStatus).every(Boolean);
};
